import * as THREE from 'three'
import { mulberry32 } from '../prng.ts'

// Document texture atlas — 4×4 cells: text blocks, spreadsheet grids, chart fragments,
// forms (FOUNDATION §6.5). Drawn procedurally, seeded.
export function makeDocumentAtlas(size = 1024): THREE.Texture {
  const canvas = document.createElement('canvas')
  canvas.width = canvas.height = size
  const ctx = canvas.getContext('2d')!
  const cell = size / 4

  for (let i = 0; i < 16; i++) {
    const r = mulberry32(i * 31 + 11)
    const cx = (i % 4) * cell
    const cy = Math.floor(i / 4) * cell
    ctx.save()
    ctx.translate(cx, cy)
    // paper
    ctx.fillStyle = '#ffffff'
    ctx.fillRect(0, 0, cell, cell)
    const m = cell * 0.09 // margin
    const w = cell - m * 2
    ctx.fillStyle = '#5A656E'
    ctx.strokeStyle = '#5A656E'

    const kind = i % 4
    if (kind === 0) {
      // text block: ragged lines
      const lines = 12 + Math.floor(r() * 5)
      for (let l = 0; l < lines; l++) {
        const y = m + (l / lines) * w
        ctx.globalAlpha = 0.55 + r() * 0.3
        ctx.fillRect(m, y, w * (0.55 + r() * 0.45) * (l === 0 ? 0.5 : 1), cell * 0.022)
      }
    } else if (kind === 1) {
      // spreadsheet grid
      ctx.globalAlpha = 0.4
      ctx.lineWidth = 1.5
      const rows = 10
      const cols = 5
      for (let rI = 0; rI <= rows; rI++) {
        const y = m + (rI / rows) * w
        ctx.beginPath(); ctx.moveTo(m, y); ctx.lineTo(m + w, y); ctx.stroke()
      }
      for (let c = 0; c <= cols; c++) {
        const x = m + (c / cols) * w
        ctx.beginPath(); ctx.moveTo(x, m); ctx.lineTo(x, m + w); ctx.stroke()
      }
      ctx.globalAlpha = 0.6
      for (let rI = 0; rI < rows; rI++)
        for (let c = 0; c < cols; c++)
          if (r() < 0.6)
            ctx.fillRect(m + (c / cols) * w + 4, m + (rI / rows) * w + 4, (w / cols) * (0.3 + r() * 0.4), cell * 0.016)
    } else if (kind === 2) {
      // bar chart fragment
      const bars = 6 + Math.floor(r() * 4)
      for (let bI = 0; bI < bars; bI++) {
        const h = w * (0.2 + r() * 0.65)
        ctx.globalAlpha = 0.5 + r() * 0.35
        ctx.fillRect(m + (bI / bars) * w + 3, m + w - h, (w / bars) * 0.65, h)
      }
      ctx.globalAlpha = 0.7
      ctx.fillRect(m, m + w, w, 2)
    } else {
      // form: labels + boxes
      const rows = 6
      for (let rI = 0; rI < rows; rI++) {
        const y = m + (rI / rows) * w
        ctx.globalAlpha = 0.7
        ctx.fillRect(m, y, w * 0.28, cell * 0.02)
        ctx.globalAlpha = 0.35
        ctx.lineWidth = 1.5
        ctx.strokeRect(m + w * 0.36, y - cell * 0.008, w * 0.6, cell * 0.05)
      }
    }
    ctx.restore()
  }

  const tex = new THREE.CanvasTexture(canvas)
  tex.minFilter = THREE.LinearMipmapLinearFilter
  tex.generateMipmaps = true
  return tex
}
